<template>
  <v-dialog v-model="show" max-width="600px" persistent>
    <v-card>
      <v-card-title class="text-h5">
        <v-icon color="primary" class="mr-2">mdi-email-send</v-icon>
        Odeslat Billing Reminder Email
      </v-card-title>

      <v-card-text>
        <div v-if="device" class="mb-4">
          <v-alert type="info" outlined>
            <strong>Zařízení:</strong> {{ device.customName || `Device ${device.id}` }}<br />
            <strong>Společnost:</strong> {{ device.companyName }}<br />
            <strong>Uživatelé:</strong> {{ device.userCount }}
          </v-alert>
        </div>

        <v-alert type="warning" outlined class="mb-4">
          <strong>Upozornění:</strong> Odešle se jednoduchý email o vypršení předplatného
          administrátorovi zařízení.
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close" :disabled="loading"> Zrušit </v-btn>
        <v-btn color="primary" @click="sendReminder" :disabled="loading" :loading="loading">
          <v-icon left>mdi-send</v-icon>
          Odeslat Email
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Success Dialog -->
    <v-dialog v-model="successDialog" max-width="500px">
      <v-card>
        <v-card-title class="text-h6">
          <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
          Email odeslán úspěšně
        </v-card-title>
        <v-card-text>
          <p><strong>Zpráva:</strong> {{ lastResult.message }}</p>
          <p v-if="lastResult.recipients"><strong>Příjemci:</strong> {{ lastResult.recipients }}</p>
          <p v-if="lastResult.messageId">
            <strong>SES Message ID:</strong> {{ lastResult.messageId }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="successDialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import { adminSendBillingReminder } from '@/graphql/mutations/adminSendBillingReminder'

export default {
  name: 'SendBillingReminderModal',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    device: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      loading: false,
      successDialog: false,
      lastResult: {},
    }
  },

  computed: {
    show: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },

  methods: {
    close() {
      this.show = false
    },

    async sendReminder() {
      this.loading = true

      try {
        const result = await this.$apollo.mutate({
          mutation: adminSendBillingReminder,
          variables: {
            deviceId: this.device.id,
          },
        })

        const response = result.data.adminSendBillingReminder

        if (response.success) {
          this.lastResult = response
          this.successDialog = true
          this.$emit('success')
          this.close()
        } else {
          this.$toast.error(response.message || 'Chyba při odesílání emailu')
        }
      } catch (error) {
        console.error('Error sending billing reminder:', error)
        this.$toast.error('Chyba při odesílání billing reminder emailu')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.v-card__text {
  padding-bottom: 0;
}
</style>
